// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Parcel = createIcon(
  <>
    <path d="M9.753 11.1213C9.25594 11.1213 8.853 11.5242 8.853 12.0213C8.853 12.5183 9.25594 12.9213 9.753 12.9213H14.2474C14.7444 12.9213 15.1474 12.5183 15.1474 12.0213C15.1474 11.5242 14.7444 11.1213 14.2474 11.1213H9.753Z" />
    <path
      clipRule="evenodd"
      d="M6.72341 3.90918C6.32278 3.90918 5.95384 4.12699 5.76029 4.47777L4.04606 7.58462C3.95627 7.74735 3.90918 7.93018 3.90918 8.11603V18.9912C3.90918 19.5987 4.40167 20.0912 5.00918 20.0912H18.9912C19.5987 20.0912 20.0912 19.5987 20.0912 18.9912V8.11603C20.0912 7.93018 20.0441 7.74735 19.9543 7.58462L18.2401 4.47777C18.0465 4.12699 17.6776 3.90918 17.277 3.90918H6.72341ZM7.13667 5.70918H11.1002V7.53278H6.13048L7.13667 5.70918ZM5.70918 9.33278V18.2912H18.2912V9.33278H5.70918ZM17.8699 7.53278L16.8637 5.70918H12.9002V7.53278H17.8699Z"
      fillRule="evenodd"
    />
  </>,
);
